import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useRedirect = (redirectTime: number, redirectRoute: string, timer = true) => {
    const [count, setCount] = useState<number>(redirectTime);
    const navigate = useNavigate();

    useEffect(() => {
        if (!timer) return;
        const interval = setInterval(() => {
            setCount((currentCount: number) => --currentCount);
        }, 1000);
        count === 0 && navigate(redirectRoute, { state: location.pathname });
        return () => clearInterval(interval);
    }, [count, navigate, redirectRoute]);

    return { count };
};
